module.exports = __webpack_public_path__ + "img/slider_b03.0c93c1a.440adac0.png";